/* © 2026 Where Are Your Keys Language Education Ltd
 *
 * This file has been modified from the original open source version as follows:
 * - added link for reporting bugs
 */

import React from 'react';
import { GoFishManagingGamesClientInterface } from "@langfish/managing-games-api-client";
import {TemplatesClientInterface} from "./creating-a-game/TemplatesClientInterface";
import {CreateGame} from "./creating-a-game/CreateGame";
import './App.css';

interface AppProps {
  client: GoFishManagingGamesClientInterface,
  templatesClient: TemplatesClientInterface
}

const App: React.FunctionComponent<AppProps> = ({ client, templatesClient }) => {
  return (
    <div className="App">
      <CreateGame templatesClient={templatesClient} managingGamesClient={client}/>
      <a id="bugReportLink" target="_blank" href="https://docs.google.com/forms/d/e/1FAIpQLSf2pULyoVzRChk4V4kmo1aPjbpbFfmApufm8h9RN-g-ydZiig/viewform?usp=dialog">🐞</a>
    </div>
  );
};

export default App;
